import { Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { ApiService } from '../core/services/api.service';
import { NotificationService } from '../core/services/notification.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Apiconfig } from '../core/helpers/apiConfig';
import { CommonModule } from '@angular/common';




@Component({
  selector: 'app-contact-us',
  standalone: true,
  imports: [FormsModule,CommonModule],
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss'
})
export class ContactUsComponent implements OnInit {
  submitted: Boolean = false
  settings: any
  acceptTerms: boolean = false; // Checkbox binding
  todayDate = new Date().toISOString().split('T')[0];
selectedTreatment: string = '';

  @ViewChild('addressForm') addressForm!: NgForm;
  constructor(private apiService: ApiService,
    private notifyService: NotificationService, 
    private route: Router,
    private activatedRoute: ActivatedRoute,) {
    // this.store.generalSettings.subscribe(result => {
    //   this.settings = result;

    // })
  }

  ngOnInit(): void {
  }

  onFormSubmit(shippingForm: any) {
    this.submitted = true;
    if (shippingForm.valid) {

      var object = {
        name: shippingForm.value.name,
        email: shippingForm.value.email,
        message: shippingForm.value.message
      }
      // contactUS
      console.log(object, "objectttttttttttttttttttt");
      this.apiService.commonApi(Apiconfig.contactUS.method, Apiconfig.contactUS.url, object).subscribe((result:any) => {
        if (result && result.status === 1) {

          this.notifyService.success("Your message has been submitted");
          // this.addressForm.value.name = ''
          // this.addressForm.value.email = ''
          // this.addressForm.value.message = ''
          // this.addressForm.reset(); 
          this.submitted = false
          shippingForm.controls.name.setValue('');
          shippingForm.controls.email.setValue('');
          shippingForm.controls.message.setValue('');
        } else {
          this.notifyService.error(result.message);
        }
      })


    }

  }

  onSubmit(form: NgForm) {
    // if (!this.acceptTerms) {
    //   this.notifyService.showError("Please accept the Terms & Conditions to submit the form.");
    //   return;
    // }

    if (form.valid) {
      console.log('Form Data:', form.value);
      // contactForm
      this.apiService.commonApi(Apiconfig.contactForm.method, Apiconfig.contactForm.url, form.value).subscribe((result:any) => {        
        if (result && result.status === 1) {
          // Success logic here
          form.resetForm();
          this.selectedTreatment = '';
          // this.acceptTerms = false; // Reset checkbox manually
          this.notifyService.success("Submitted Successfully");
        } else {
          this.notifyService.error(result.message);
        }
      })

    } else {
      console.log('Form Invalid');
    }
  }

}
